import type {
  MainStateType,
  PagesStateType,
  ActivePageStateType,
  EntitiesStateType,
} from './context';
import { PagesActions, ActionTypes, EntitiesActions } from './actionTypes';

export const pagesReducer = (state: PagesStateType, action: PagesActions): PagesStateType => {
  switch (action.type) {
    case ActionTypes.RECEIVE_PAGE:
      return [
        ...state.map(page => (page.id === action.payload.page.id ? action.payload.page : page)),
      ];
    case ActionTypes.RECEIVE_PAGES:
      return [...action.payload.pages];
    default:
      return state;
  }
};

export const activePageReducer = (
  state: MainStateType,
  action: PagesActions
): ActivePageStateType => {
  switch (action.type) {
    case ActionTypes.SET_ACTIVE_PAGE:
      return { ...state.pages.find(page => page.type === action.payload.activePageType) };
    default:
      return state.activePage;
  }
};

export const entitiesReducer = (
  state: EntitiesStateType,
  action: EntitiesActions
): EntitiesStateType => {
  switch (action.type) {
    case ActionTypes.RECEIVE_ENTITIES:
      return {
        ...state,
        ...action.payload.entities,
      };
    default:
      return state;
  }
};

export const mainReducer = (
  { activePage, pages, entities }: MainStateType,
  action: PagesActions | EntitiesActions
): MainStateType => {
  return {
    // @ts-ignore
    activePage: activePageReducer({ activePage, pages }, action),
    // @ts-ignore:
    entities: entitiesReducer(entities, action),
    // @ts-ignore
    pages: pagesReducer(pages, action),
  };
};
